export default "__VITE_ASSET__Bcdpcjqo__"